import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const getalltopics = async (params) => {
  const { usertype} = params;
  let response = await api.get("getAllTchExtraModulesTopics/" + usertype + "/" + "od");
  return response.data;
};

export const getalldata = async (data) =>
await api.get(
`getTchExtraModulesContentsQuiz/${data.usertype}/${data.topicId}`
);

export const updateassignmentquestion = async (reqbody) => {
  let response = await api.put("updateTchExtraModulesContentAssignmentData", reqbody);
  return response.data;
};

export const deleteExtraAssignmentThunk = async(data) =>
await api.put(`updateTchExtraModulesContentAssignmentData`,data);